import React from 'react'
import { useAtom } from 'jotai'
import Classnames from 'classnames'

// helper functions
import { returnValue } from '@/utils/op-types/helperFunctions'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
} from '@/utils/op-types/store'

// block renderer
import BlockRenderer from '@/components/optypes/frontend/BlockRenderer'

// block builder tools
import StaticContentWrapper from '@/components/optypes/frontend/StaticContentWrapper'
import AddBlockBuilder from '@/components/optypes/frontend/AddBlockBuilder'

// blocks
import LinkBlock from '@/components/optypes/frontend/SimpleResourceList/blocks/LinkBlock'

import OnepagerFooter from '@/components/optypes/headlesss-components/OnepagerFooter'

const Components = {
  linkblock: LinkBlock,
}

const MainComponentRenderer = () => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  return (
    <div
      className="relative"
      style={{
        backgroundColor: returnValue('bgcolor', opDesign, pageDesign),
        color: returnValue('textcolor', opDesign, pageDesign),
      }}
    >
      <div
        className="relative px-6 md:px-0"
        style={{
          backgroundColor: returnValue('headerbgcolor', opDesign, pageDesign),
          color: returnValue('headertextcolor', opDesign, pageDesign),
        }}
      >
        {/* background image */}
        {returnValue('headerbgimage', opDesign, pageDesign) && (
          <div
            className={Classnames(
              'top-0 left-0 z-0 h-full w-full  bg-cover bg-no-repeat',
              {
                absolute:
                  returnValue('bgtype', opDesign, pageDesign) == 'absolute',
                fixed: returnValue('bgtype', opDesign, pageDesign) == 'fixed',
                'bg-center':
                  returnValue('headerbgposition', opDesign, pageDesign) ==
                  'center',
                'bg-top':
                  returnValue('headerbgposition', opDesign, pageDesign) ==
                  'top',
                'bg-bottom':
                  returnValue('headerbgposition', opDesign, pageDesign) ==
                  'bottom',
              }
            )}
            style={{
              backgroundImage: `url(${returnValue(
                'headerbgimage',
                opDesign,
                pageDesign
              )})`,
              opacity: returnValue('headerbgopacity', opDesign, pageDesign),
            }}
          ></div>
        )}

        <div className="container relative z-10 mx-auto max-w-5xl py-10 mb-6 md:mb-0 md:py-20 flex flex-col items-center justify-center">
          <h4 className="text-lg font-medium mb-6 text-center md:w-1/2">
            <StaticContentWrapper contentKey="preheadline">
              {returnValue('preheadline', opStatic, pageStatic)}
            </StaticContentWrapper>
          </h4>

          <h2
            className="block text-5xl md:text-7xl font-bold py-4 px-6"
            style={{
              backgroundColor: returnValue(
                'headlinebgcolor',
                opStatic,
                pageStatic
              ),
              color: returnValue('headlinetextcolor', opStatic, pageStatic),
            }}
          >
            <StaticContentWrapper contentKey="headline">
              {returnValue('headline', opStatic, pageStatic)}
            </StaticContentWrapper>
          </h2>

          <h3 className="text-xl font-medium mt-6 text-center md:w-1/2">
            <StaticContentWrapper contentKey="subheadline">
              {returnValue('subheadline', opStatic, pageStatic)}
            </StaticContentWrapper>
          </h3>
        </div>
      </div>

      {/* list of blocks */}
      <div className="container mx-auto max-w-5xl mb-12 mt-2 md:mt-10 px-6 md:px-0">
        <div className="space-y-20">
          {pageBlocks.map((block, index) => (
            <BlockRenderer
              key={index}
              index={index}
              Components={Components}
              block={block}
            />
          ))}
        </div>

        {/* add block button builder */}
        {builder && (
          <div className="mt-8 relative z-10">
            <AddBlockBuilder
              bgColor="bg-blue-600 hover:bg-blue-500"
              autoType="linkblock"
              btnText="Add Link Block"
            />
          </div>
        )}
      </div>

      <div className="py-12 relative z-20">
        <OnepagerFooter />
      </div>
    </div>
  )
}

export default MainComponentRenderer
